var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SfLink',{staticClass:"font-medium no-underline text-base border-b-4 py-5 block",attrs:{"link":_vm.link}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }